import { render, staticRenderFns } from "./UserRequisitesFilters.vue?vue&type=template&id=8ec1c742&"
import script from "./UserRequisitesFilters.vue?vue&type=script&lang=js&"
export * from "./UserRequisitesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports